<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.studentName" placeholder="学生姓名" clearable></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.phone" placeholder="家长手机" clearable></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1; getData()">查询</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)"
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="studentName" label="学生姓名" min-width="110" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="className" label="班级名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="phone" label="家长手机" min-width="120" :show-overflow-tooltip="true"></el-table-column>

                <el-table-column prop="startTime" label="开始时间" width="160">
                    <template slot-scope="scope">
                        {{ scope.row.startTime }}
                    </template>
                </el-table-column>
                <el-table-column prop="recTime" label="接听时间" width="160">
                    <template slot-scope="scope">
                        {{ scope.row.recTime }}
                    </template>
                </el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="160">
                    <template slot-scope="scope">
                        {{ scope.row.endTime}}
                    </template>
                </el-table-column>

                <el-table-column prop="durationSecond" label="通话时长" width="110">
                    <template slot-scope="scope">
                        {{ formatDuration(scope.row.durationSecond) }}
                    </template>
                </el-table-column>
                <el-table-column prop="callType" label="通话类型" width="110">
                    <template slot-scope="scope">
                        {{ callTypeLabel(scope.row.callType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="结果" width="120">
                    <template slot-scope="scope">
                        {{ reasonLabel(scope.row.reason) }}
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="创建时间" width="160">
                    <template slot-scope="scope">
                        {{ scope.row.createdAt}}
                    </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="80px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button style="color: red" @click.native.prevent="del(scope.row)" type="text" size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';

    export default {
        name: "CallDetail",
        data(){
            return{
                loading:false,
                loadingText:"",
                menuName:"",
                depts:[],
                data:[],
                form:{
                    deptId:"",
                    studentName:"",
                    phone:"",
                    id:""
                },
                common:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100],
                },
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                let url  = this.listDeptUrl;
                let data = { parentId:"0" };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts = res.data.list || [];
                        if(this.depts.length > 0){
                            this.form.deptId = this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading = true;
                this.loadingText = "数据加载中...";
                let url  = this.callDetailListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    studentName:this.form.studentName,
                    phone:this.form.phone
                };
                this.apiPost(url,data).then((res) => {
                    this.loading = false;
                    if(res.status==200){
                        this.data = res.data.list || res.data.data || [];
                        this.common.total = res.data.total || 0;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading = false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            del(row){
                this.form.id = row.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.callDetailRemoveUrl;
                let data = { id: this.form.id };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            callTypeLabel(v){
                if(v == 1) return '视频';
                if(v == 2) return '语音';
                if(v == 3) return '落地';
                if(v == 4) return 'sim卡';
                if(v == 5) return '小程序视频';
                if(v == 6) return '小程序语音';
                return '-';
            },
            reasonLabel(v){
                if(v == 0) return '正常';
                if(v == 1) return '家长未接听';
                if(v == 2) return '余额不足';
                if(v == 100) return '未知';
                return '-';
            },
            formatTime(ts){
                if(ts === null || ts === undefined || ts === ''){
                    return '';
                }
                let t = ts;
                if(typeof t === 'string' && /^\d+$/.test(t)){
                    t = parseInt(t, 10);
                }
                if(typeof t === 'number' && t < 1000000000000){
                    t = t * 1000;
                }
                let d = new Date(t);
                if(isNaN(d.getTime())){
                    return ts;
                }
                let pad = (n) => (n < 10 ? ('0'+n) : ''+n);
                return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
            },
            formatDuration(sec){
                if(sec === null || sec === undefined || sec === ''){
                    return '';
                }
                let s = sec;
                if(typeof s === 'string' && /^\d+$/.test(s)){
                    s = parseInt(s, 10);
                }
                if(typeof s !== 'number' || isNaN(s) || s < 0){
                    return sec;
                }
                if(s < 60){
                    return s + '秒';
                }
                if(s < 3600){
                    let m = Math.floor(s / 60);
                    let r = s % 60;
                    return r === 0 ? (m + '分') : (m + '分' + r + '秒');
                }
                let h = Math.floor(s / 3600);
                let m = Math.floor((s % 3600) / 60);
                let r = s % 60;
                let str = h + '时';
                if(m > 0){
                    str += m + '分';
                }
                if(r > 0){
                    str += r + '秒';
                }
                return str;
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
    .table{
        width: 100%;
        font-size: 14px;
    }
</style>




// WEBPACK FOOTER //
// src/components/page/hsc/CallDetail.vue